import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/EEdT_Thumbnail.png'
import _imports_1 from '@/assets/images/white-logo.svg'


const _hoisted_1 = { class: "m-auto m-1230" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "mw-480 ms-lg-auto" }
const _hoisted_5 = { class: "form-group mb-3" }
const _hoisted_6 = { class: "input-error" }
const _hoisted_7 = { class: "strength-bar" }
const _hoisted_8 = { class: "form-group mb-3" }
const _hoisted_9 = { class: "input-error" }
const _hoisted_10 = { class: "form-group mb-3" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "d-flex align-items-center justify-content-center py-1" }
const _hoisted_13 = {
  key: 0,
  class: "material-symbols-outlined text-white fs-20 me-2"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 2,
  class: "spinner-border spinner-border-sm me-2",
  "aria-hidden": "true"
}
const _hoisted_16 = {
  key: 3,
  role: "status"
}
const _hoisted_17 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-lg-6 d-none d-lg-block" }, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "rounded-3",
          alt: "login"
        })
      ], -1 /* HOISTED */)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"d-inline-block mb-4\"><img src=\"/favicon-32x32.png\" class=\"rounded-3 for-light-logo\" alt=\"login\"><img src=\"" + _imports_1 + "\" class=\"rounded-3 for-dark-logo\" alt=\"login\"></div><h3 class=\"fs-28 mb-2\">Cambiar contraseña</h3><p class=\"fw-medium fs-16 mb-4\"> Ingresa una nueva contraseña </p>", 3)),
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validateForm && _ctx.validateForm(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "label text-secondary" }, "Contraseña nueva", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "password",
                class: "form-control",
                placeholder: "Ingresa tu nueva contraseña",
                id: "newPassword",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userPasswordReset.newPassword) = $event)),
                onInput: _cache[1] || (_cache[1] = ($event: any) => {_ctx.clearError('newPassword');_ctx.checkStrength()})
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, _ctx.userPasswordReset.newPassword]
              ]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.errors.newPassword), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(["strength", _ctx.strengthClass]),
                  style: _normalizeStyle({ width: _ctx.strengthPercent + '%' })
                }, null, 6 /* CLASS, STYLE */)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "label text-secondary" }, "Confirmar contraseña", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "password",
                class: "form-control",
                placeholder: "Confirma tu contraseña",
                id: "confirmPassword",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userPasswordReset.confirmPassword) = $event)),
                onInput: _cache[3] || (_cache[3] = ($event: any) => {_ctx.clearError('confirmPassword'); })
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelText, _ctx.userPasswordReset.confirmPassword]
              ]),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.errors.confirmPassword), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                type: "submit",
                disabled: _ctx.isLoading,
                class: "btn btn-primary fw-medium py-2 px-3 w-100"
              }, [
                _createElementVNode("div", _hoisted_12, [
                  (!_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_13, " autorenew "))
                    : _createCommentVNode("v-if", true),
                  (!_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Enviar"))
                    : _createCommentVNode("v-if", true),
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                    : _createCommentVNode("v-if", true),
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Procesando..."))
                    : _createCommentVNode("v-if", true)
                ])
              ], 8 /* PROPS */, _hoisted_11)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", null, [
                _cache[8] || (_cache[8] = _createTextVNode(" Regresar ")),
                _createVNode(_component_RouterLink, {
                  to: "/login",
                  class: "fw-medium text-primary text-decoration-none"
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode(" al Login ")
                  ])),
                  _: 1 /* STABLE */
                })
              ])
            ])
          ], 32 /* NEED_HYDRATION */)
        ])
      ])
    ])
  ]))
}